export enum WriterFormType {
    add = 'ADD',
    create = 'CREATE',
    afterFind = 'AFTER_FIND',
}
